import { User } from './interface';
import { getUserInfo } from 'service/ad-user';
import { observable, runInAction } from 'mobx';

export class AdUserModel {
    @observable
    user: User;

    dmpKeywordsUser: boolean;

    uploadUserId: boolean;

    isCRMLogin: boolean;

    dmpOrientationPush: boolean;

    dmpSQLCreateWhiteList: boolean;

    async initialize(redirectUrl) {
        const userInfo = await getUserInfo(redirectUrl);
        const {
            user,
            dmpKeywordsUser,
            uploadUserId,
            agentUserId,
            adminUserId,
            dmpOrientationPush,
            dmpSQLCreateWhiteList,
        } = userInfo;
        runInAction(() => {
            this.user = user;
            this.dmpKeywordsUser = dmpKeywordsUser;
            this.uploadUserId = uploadUserId;
            this.dmpOrientationPush = dmpOrientationPush;
            this.isCRMLogin = !!agentUserId || !!adminUserId;
            this.dmpSQLCreateWhiteList = dmpSQLCreateWhiteList;
        });
    }
}

export default new AdUserModel();
